/**
 * 接口异常状态码匹配
 * checkOrderTicket
 * checkTicketFlight
 * checkFlightDate
 * afterSaleChangeReqNewFlightDetail
 * queryChangeCost
 * getNameAndPhone
 * @param {string} code
 * @returns {boolean}
 */
export default function getInterfaceError(code) {
    return /(1111)|(4002)|(5003)|(5005)|(5006)|(8005)|(40001)|(60010)|(60011)|(80004)|(80006)|(80008)|(90000)|(90001)|(91002)|(91004)/g.test(code);
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getInterfaceError.js
// module id = null
// module chunks = 